module.exports = __webpack_public_path__ + "static/img/FreeLace_Pro.8790c9eb.jpg";